import GenericOAuthIntegration from 'models/application/integration/GenericOAuthIntegration';

export default class GenericOAuthIntegrationService {
	toModel(integration) {
		return new GenericOAuthIntegration(integration);
	}
}
